import React, { useState, useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  Filter,
  AutocompleteInput,
  TextInput,
  BulkDeleteButton,
} from 'react-admin';
import { useStore } from 'react-redux';
import { SecuredComponent, asyncFetch } from '../ReactAdminOss._Core/src';

export default props => {
  // обикновено заявки правя от компонента в който ще ползвам данните но на реакт админа филтър компонента се пререндерира заради промянва в props
  // единсвтения начин в който успях да избегна двойна завка към микросервиза беше когато направя заявката тук и подам резултатите към филтъра
  const [lastNames, setLastNames] = useState([]);
  const store = useStore();

  useEffect(() => {
    if (lastNames.length === 0) {
      (async () => {
        const data = await asyncFetch(
          `${process.env.REACT_APP_TEMPLATE_API}/Colleagues/GetLastNames`
        );
        setLastNames(data.lastNames);
      })();
    }
  }, [lastNames]);

  return (
    <SecuredComponent permission="colleagues_view" store={store}>
      <List
        {...props}
        title="Colleagues"
        filters={<ColleaguesFilter lastNames={lastNames} />}
        bulkActionButtons={<BulkActionButtons />}
      >
        <Datagrid>
          <TextField source="firstName" />
          <TextField source="lastName" />
        </Datagrid>
      </List>
    </SecuredComponent>
  );
};

const ColleaguesFilter = props => {
  const { lastNames, ...restProps } = props;

  return (
    <Filter variant="standard" {...restProps}>
      <TextInput label="First name" source="firstName" alwaysOn />
      <AutocompleteInput
        label="Last names"
        source="lastNameId"
        choices={lastNames}
        alwaysOn
        allowEmpty
        emptyText="Премахни филтър"
      />
    </Filter>
  );
};

const BulkActionButtons = props => (
  <>
    <BulkDeleteButton {...props} />
  </>
);
